__turbopack_context__.v({
  "optionChainTableContainer": "OptionChainTableDesktop-module-scss-module__t381Ma__optionChainTableContainer",
});
